module.exports = __webpack_public_path__ + "img/truckTrailerRearLeftOutline.67fb6855.svg";